import { ReactElement, ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import cn from "classnames";
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import { ClockCircleOutlined } from "@ant-design/icons";

import { CandidateAssessmentViewTypes } from "@/modules/candidate/assessment/CandidateAssessment/CandidateAssessment";

import MarkdownPreviewCustom from "@/ui-components/commonComponents/MarkdownPreviewCustom/MarkdownPreviewCustom";
import ParagraphWithIcon from "@/ui-components/commonComponents/ParagraphWithIcon/ParagraphWithIcon";

import style from "./style.module.css";

export interface IWelcomeElement {
  type: CandidateAssessmentViewTypes;
  title?: string;
  description: string | undefined;
  children?: ReactElement<any, any> | null;
  footer?: ReactElement<any, any> | null;
  leftTime?: string;
  timerDisabled?: boolean;
  languageIndicator?: ReactNode;
}

export default function WelcomeElement({
  type,
  title,
  description,
  children,
  footer,
  leftTime,
  timerDisabled = false,
  languageIndicator,
}: IWelcomeElement) {
  const { xxl, xl, lg } = useBreakpoint();
  const isDesktopView = xxl || xl || lg;
  const intl = useIntl();

  return (
    <div className={cn({ [style.desktopContainer]: isDesktopView, [style.mobileContainer]: !isDesktopView })}>
      <div
        className={cn(style.componentWrapper, {
          [style.finishComponent]: type === CandidateAssessmentViewTypes.finish,
        })}
      >
        <div
          className={cn(style.title, {
            [style.desktopTitle]: isDesktopView,
          })}
        >
          {title ? title : <FormattedMessage id="candidate.welcome.thankYou" defaultMessage="Thank You" />}
        </div>

        {type === CandidateAssessmentViewTypes.start && (
          <div className={style.mobileStatisticsContainer}>
            <ParagraphWithIcon
              text={
                timerDisabled
                  ? intl.formatMessage({ id: "candidate.welcome.untimed", defaultMessage: "Untimed" })
                  : `${leftTime ? leftTime : 0}`
              }
            >
              <ClockCircleOutlined aria-hidden="true" />
            </ParagraphWithIcon>
            {languageIndicator}
          </div>
        )}
        {description && (
          <div
            className={cn(style.introOutroTexts, { [style.outroText]: type === CandidateAssessmentViewTypes.finish })}
          >
            <MarkdownPreviewCustom source={description} style={{ fontWeight: 400 }} />
          </div>
        )}
        {(type === CandidateAssessmentViewTypes.start || type === CandidateAssessmentViewTypes.finish) && children}
      </div>
      {type === CandidateAssessmentViewTypes.start && footer && <div className={style.footerContainer}>{footer}</div>}
    </div>
  );
}
